<template>
    <Fragment>
        <div class="col-lg-4">
            <AddressCheckout
            :user="user"
            @address-updated="updateMainAddress"
            />
        </div>
        <div class="col-lg-4">
            <ShippingCheckout
            :mainAddress="mainAddressCopy"
            />
        </div>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import AddressCheckout from "./AddressCheckout";
import ShippingCheckout from "./ShippingCheckout";
import { mapActions } from "vuex";

export default {
    name: "Checkout",
    props: {
        mainAddress: { default: null },
        user: {default: null},
        novoAddress: {default: null}
    },
    components: {
        Fragment,
        AddressCheckout,
        ShippingCheckout
    },
    data() {
        return {
            mainAddressCopy: this.mainAddress
        };
    },
    created() {
        this.ActionSetMainAddress(this.mainAddress);
    },
    methods: {
        ...mapActions("address", ["ActionSetMainAddress"]),
        updateMainAddress(newAddress) {
            this.mainAddressCopy = { ...newAddress };
            this.ActionSetMainAddress(this.mainAddressCopy);
        }
    }
};
</script>
